import React, {Fragment} from 'react';
import InvoiceItemComponent from './InvoiceItemComponent';
import PreviousInvoicesComponent from './PreviousInvoicesComponent';
import InvoiceEmptyItemComponent from './InvoiceEmptyItemComponent';
import {Row, Col} from 'reactstrap';

const InvoiceDataComponent = (props) => {
  const {id, invoices, collapse, isMobile, style = 'empty', error, isNewCustomer = false, billCycle} = props;
  const cssClasses = ['invoice-box-container mr-auto ml-auto', style];
  if (collapse) cssClasses.push('previous-opened');

  return invoices && !error ? (
    <Fragment>
      <Row>
        <Col md={12} className={cssClasses.join(' ').trim()}>
          <InvoiceItemComponent
            data={invoices[0]}
            previous={false}
            ban={id}
            isDisconnected={props.isDisconnected}
            accountType={props.accountType}
          />
        </Col>
      </Row>
      <Row>
        <PreviousInvoicesComponent key={id} invoices={invoices} collapse={collapse} style={style} />
      </Row>
    </Fragment>
  ) : (
    <Col md={12} className={cssClasses.join(' ').trim()}>
      <InvoiceEmptyItemComponent error={error} previous={false} isNewCustomer={isNewCustomer} billCycle={billCycle} isMobile={isMobile} />
    </Col>
  );
};
export default InvoiceDataComponent;
